import React, {Component} from 'react';

class scholar extends Component {
	constructor(props) {
		super(props);
	}

  onChange = () => {
    console.log('인풋 박스 값 바뀜');
  }

	render() {

		return (
			<>
        <div className="card maxWidthInit p-0">
          <div className="card-header">
            연구자 분석
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-7">
                <div className="form-group">
                  <label><strong>연구자 검색</strong></label>
                  <div className="input-group">
                    <input type="text" className="form-control" onChange={this.onChange} />
    
                    <button type="button" className="btn btn-outline-secondary btn-sm">
                    검색
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group">
                  <label><strong>년도</strong></label>
                  <div className="input-group">
                    <input type="text" className="form-control" value="" onChange={this.onChange} />
                    <span className="input-group-text">~</span>
                    <input type="text" className="form-control" value="" onChange={this.onChange} />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12 form-group">
                <label htmlFor="journal_title"><strong>신분</strong></label>
                <div className="input-group">
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" onChange={this.onChange} checked />
                    <label className="form-check-label" htmlFor="inlineCheckbox1">교수</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox2">기금교수</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox3" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox3">HK교수</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox4" value="option3" onChange={this.onChange} checked />
                    <label className="form-check-label" htmlFor="inlineCheckbox4">명예교수</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox5" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox5">기타교수</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox6" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox6">병원교수</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox7" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox7">연구원</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox8" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox8">강사</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox9" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox9">대학원생</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox10" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox10">직원</label>
                  </div>
                  <div className="form-check form-check-inline mr-3">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox11" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox11">조교</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" id="inlineCheckbox12" value="option3" onChange={this.onChange} />
                    <label className="form-check-label" htmlFor="inlineCheckbox12">학부생</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-7">
                <div className="form-group">
                  <label><strong>단과 및 학과</strong></label>
                  <div className="input-group">
                    <select className="form-select mr-4">
                      <option selected="selected">전체</option>
                      <option value="1">공과대학</option>
                      <option value="2">사범대학</option>
                      <option value="3">자연과학대학</option>
                      <option value="4">인문대학</option>
                    </select>
                    <select className="form-select mr-4">
                      <option selected="selected">전체</option>
                      <option value="1">고분자공학과</option>
                      <option value="2">재료공학부</option>
                      <option value="3">전자공학과</option>
                    </select>
                    <select className="form-select mr-4">
                      <option selected="selected">전공</option>
                    </select>
    
                    <button type="button" className="btn btn-primary btn-sm">
                      추가
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer text-right">
            <button type="button" className="btn btn-primary btn-sm">
              검색
            </button>
          </div>			
        </div>
    
        <div className="mt-4">
          <div className="row mb-2">
            <div className="col-sm-9">
              <label className="m-0">
                * 연도별 숫자 합계 클릭 또는 <span>데이터 다운로드</span> 클릭 시 상세정보 다운로드가 가능합니다.
              </label>
            </div>
            <div className="col-sm-3">
              <div className="input-group">
                <input type="text" className="form-control" onChange={this.onChange} />
    
                <button type="button" className="btn btn-outline-secondary btn-sm">
                  검색
                </button>
    
                <button type="button" className="btn btn-secondary btn-sm ml-1">
                  분석 리포트
                </button>
                <button type="button" className="btn btn-secondary btn-sm ml-1">
                  표 다운로드
                </button>
              </div>
            </div>
          </div>
    
          <table className="table table-striped table-thin border-bottom">
            <colgroup>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">선택</th>
                <th scope="col">이름</th>
                <th scope="col">단과 대학</th>
                <th scope="col">학과</th>
                <th scope="col">전공</th>
                <th scope="col">SICE</th>
                <th scope="col">SSCI</th>
                <th scope="col">Scopus</th>
                <th scope="col">KCI</th>
                <th scope="col">합계</th>
                <th scope="col">피인용횟수(TC) 합계</th>
                <th scope="col">TC 있는 논문건수</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><input type="checkbox" className="ml-0" onChange={this.onChange} /></td>
                <td>펭수</td>
                <td>자연과학대학</td>
                <td>해양학과</td>
                <td>극지방연구</td>
                <td>0</td>
                <td>24</td>
                <td>5</td>
                <td>0</td>
                <td>24</td>
                <td>0</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        </div>
			</>
		)
	}
}

export default scholar;
